import { queryPatientsBySearch } from 'src/gql/queries/queryAllPatients'
import { queryPatientsByPractice } from 'src/gql/queries/queryPatientsInPractice'

export const patientsServices = {
  getAllPatients: queryPatientsByPractice,
  getPatientBySearch: queryPatientsBySearch,
}

export type PatientsServices = typeof patientsServices
